module.exports = __webpack_public_path__ + "img/note-bell.03366de6.svg";